export interface IMandrillEmailMessageTemplate {
  name: string;
  mergeVars: Array<{ name: string; content: string }>;
}

export interface IMandrillEmailPreviewRequestModel {
  templateName: string;
  mergeVars: Array<{ name: string; content: string }>;
}

export class ButtonTexts {
  public static TeamInvitation = 'View Invitation Details';
  public static InvitationToPortal = 'Invitation To Portal';
}

export class MandrillEmailTemplateSettings {
  public static subject = 'SUBJECT';
  public static currentYear = 'CURRENT_YEAR';
  public static fName = 'FNAME';
  public static sender = 'sender';
  public static logoUrl = 'logo_url';
  public static workspaceLogoUrl = 'workspace_logo_url';
  public static link = 'link';
  public static emailHeader = 'email_header';
  public static emailContent = 'email_content';
  public static buttonText = 'button_text';
  public static teamName = 'team_name';
  public static organization = 'organization';
  public static organizationName = 'organization_name';
  public static organizationEmail = 'organization_email';
  public static organizationAdmin = 'organization_admin';
  public static unsubscribe = 'unsubscribe';
  public static managePreferences = 'manage_preferences';
}
